"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const AITable_1 = tslib_1.__importDefault(require("../hosts/AITable"));
const getHostId = (host) => host.id;
const StorageTable = (_a) => {
    var { hosts } = _a, rest = tslib_1.__rest(_a, ["hosts"]);
    return (React.createElement(AITable_1.default, Object.assign({ getDataId: getHostId, data: hosts }, rest), ''));
};
exports.default = StorageTable;
//# sourceMappingURL=StorageTable.js.map